import {
  AnySession,
  Session as FullSession,
  OptionalCustomerSession,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/session.types';
import {useRef} from 'react';
import {useBasketToken} from '../basketStore/BasketTokenProvider';
import {useAnySession, useFullSession, useOptionalSession} from './useSession';

type Session = FullSession | OptionalCustomerSession | AnySession | null;

/**
 * This hook should not be exported and only used internally
 * @param session
 * @returns
 */
function useTokenReliantSession<T extends Session>(session: T) {
  const refSession = useRef(session);
  const {waitForBasketTokenOnClientRequest} = useBasketToken();

  const basketLoaded = !waitForBasketTokenOnClientRequest;

  if (!basketLoaded || !session || session.type?.$case === 'noSession') {
    return {
      session: refSession.current,
      refetchesDisabled: !!process.browser,
    };
  }

  return {
    session,
    refetchesDisabled: false,
  };
}

export const useBasketTokenAwaitedFullSession = () => {
  const session = useFullSession();

  return useTokenReliantSession(session);
};

export const useBasketTokenAwaitedOptionalSession = () => {
  const session = useOptionalSession();

  return useTokenReliantSession(session);
};

export const useBasketTokenAwaitedAnySession = () => {
  const session = useAnySession();

  return useTokenReliantSession(session);
};
